import type { UpdateTruckInput } from '@chukua/common';
import type { TruckClass } from '../../../../reference-data/reference-data.api';
import { TruckDetailsForm } from './TruckDetailsForm';
import { TruckOdometerCard } from './TruckOdometerCard';
import type { TruckDetail } from '../trucks.api';

interface TruckDetailsTabProps {
  truck: TruckDetail;
  truckClasses: TruckClass[];
  canManage: boolean;
  error: string | null;
  saving: boolean;
  onSave: (input: UpdateTruckInput) => Promise<boolean>;
  onRecordReading: (odometerKm: number) => Promise<boolean>;
}

/** The odometer card (its own "Record reading" control) above the editable record — CLAUDE.md: the odometer only moves through a reading. */
export function TruckDetailsTab({ truck, truckClasses, canManage, error, saving, onSave, onRecordReading }: TruckDetailsTabProps) {
  return (
    <div className="flex flex-col gap-8">
      <TruckOdometerCard
        currentOdometerKm={truck.currentOdometerKm}
        odometerRecordedAt={truck.odometerRecordedAt}
        canManage={canManage}
        onRecord={onRecordReading}
      />
      <TruckDetailsForm truck={truck} truckClasses={truckClasses} canManage={canManage} error={error} saving={saving} onSave={onSave} />
    </div>
  );
}
